import { Dialog, DialogContent, DialogTitle, Typography, Divider, Grid, Stack, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { formatCurrency } from "src/helper/convertNum";
import useDebtHistoryDetail from "src/hooks/debt/useDebtHistoryDetail";
import dayjs from "dayjs";
import convertCurrency from "src/helper/convertCurrency";
import CopyToClipboard from "src/components/shared/CopyToClipboard";
import usePreviewPdf from "../../hooks/usePreviewPdf";
import DebtSalesPrintDialog from "./DebtSalesPrintDialog";
import useAppGlobal from "src/context/useAppGlobal";

export default function DebtSalesHistoryDetailDialog({ open, onClose, selectedRow, isAllTab = false }) {
  const { data } = useDebtHistoryDetail(selectedRow?.paymentLog ?? selectedRow?._id);
  const { handleOpenDialog } = useAppGlobal();
  const { onPrintOrder } = usePreviewPdf();

  const handlePreview = (row) => {
    handleOpenDialog({
      title: "Xem phiếu xuất",
      size: "xl",
      content: <DebtSalesPrintDialog item={row} />,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{ sx: { borderRadius: "16px" } }}
    >
      <DialogTitle sx={{ pb: 1, fontWeight: "bold", px: 3 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            fontWeight="bold"
            fontSize="inherit"
          >
            Chi tiết Lịch sử thanh toán công nợ
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ p: 4 }}>
        <Divider sx={{ bgcolor: "#E0E0E0", borderColor: "#E0E0E0", borderTopWidth: "0px" }} />
        <Stack
          spacing={3}
          mt="8px"
        >
          <Grid
            container
            rowSpacing={1}
          >
            <Grid
              item
              xs={6}
            >
              <Stack spacing={1.5}>
                <Box>
                  <Typography color="#989898">Nhân viên kinh doanh</Typography>
                  <Typography fontWeight="bold">{data?.data?.sales?.fullName ?? "-"}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Khách hàng</Typography>
                  <Typography fontWeight="bold">{data?.data?.customer?.fullName ?? "-"}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Hình thức thanh toán</Typography>
                  <Typography fontWeight="bold">{data?.data?.method === "Cash" ? "Tiền mặt" : "Chuyển khoản"}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Số tiền thanh toán</Typography>
                  <Typography fontWeight="bold">{formatCurrency(data?.data?.totalPaid ?? 0)}</Typography>
                  <Typography
                    color="#989898"
                    fontSize="12px"
                    fontStyle="italic"
                  >
                    {convertCurrency(data?.data?.totalPaid ?? 0)} đồng
                  </Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Ngày thanh toán</Typography>
                  <Typography fontWeight="bold">{data?.data?.paymentDate ? dayjs(data?.data?.paymentDate).format("DD/MM/YYYY") : "-"}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Kế toán xử lý</Typography>
                  <Typography fontWeight="bold">{data?.data?.sales?.fullName ?? "-"}</Typography>
                </Box>
              </Stack>
            </Grid>
            <Grid
              item
              xs={6}
            >
              <Stack spacing={1.5}>
                <Box>
                  <Typography color="#989898">Ngày đi tiền trên nội dung chuyển khoản</Typography>
                  <Typography fontWeight="bold">{data?.data?.paymentDate ? dayjs(data?.data?.paymentDate).format("DD/MM/YYYY") : "-"}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Số tài khoản nhận thanh toán</Typography>
                  <Typography fontWeight="bold">{`${data?.data?.bankInfo?.ownerName ?? ""} ${data?.data?.bankInfo?.ownerName ? "-" : ""} STK ${data?.data?.bankInfo?.accountNumber ?? "-"}`}</Typography>
                  <Typography fontStyle="italic">{data?.data?.bankInfo?.bankName ?? "-"}</Typography>
                  <Typography fontStyle="italic">{data?.data?.bankInfo?.branchName ?? "-"}</Typography>
                </Box>
                <Box>
                  <Typography color="#989898">Ghi chú</Typography>
                  <Typography fontWeight="bold">{data?.data?.note ?? "-"}</Typography>
                </Box>
              </Stack>
            </Grid>
          </Grid>

          <Divider sx={{ bgcolor: "#E0E0E0", borderColor: "#E0E0E0", borderTopWidth: "0px" }} />

          <Stack spacing={2}>
            <Typography fontWeight="bold">Chi tiết Phiếu xuất được thanh toán</Typography>
            <Box
              sx={{
                borderRadius: "12px",
                border: "1px solid var(--grey)",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "10% 35% 25% 30%",
                  borderBottom: "1px solid var(--grey)",
                  px: 3,
                  py: 1.5,
                  backgroundColor: "var(--white)",
                }}
              >
                <Typography
                  fontWeight="bold"
                  align="left"
                >
                  STT
                </Typography>
                <Typography
                  fontWeight="bold"
                  align="left"
                >
                  Mã Phiếu xuất được thanh toán
                </Typography>
                <Typography
                  fontWeight="bold"
                  align="right"
                >
                  Số tiền thanh toán
                </Typography>
                <Typography
                  fontWeight="bold"
                  align="left"
                  sx={{ px: 3 }}
                >
                  Mã Đơn hàng
                </Typography>
              </Box>
              {data?.data?.inventoryNotes?.map((row, index) => (
                <Box
                  key={row.stt}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "10% 35% 25% 30%",
                    px: 3,
                    py: 1.5,
                    borderBottom: "1px solid var(--grey)",
                    "&:last-of-type": { borderBottom: "none" },
                  }}
                >
                  <Typography>{index + 1}</Typography>
                  <Typography
                    color="#007AFF"
                    sx={{ cursor: "pointer" }}
                    onClick={() => handlePreview(row)}
                  >
                    {row?.code ?? "-"}
                  </Typography>
                  <Typography align="right">{formatCurrency(row?.subTotal ?? 0)}</Typography>
                  <Typography
                    color="#007AFF"
                    sx={{ cursor: "pointer", px: 3 }}
                  >
                    {row?.contextCode ? (
                      <CopyToClipboard
                        value={row?.contextCode}
                        isCenter={false}
                        color="#007AFF"
                      />
                    ) : (
                      "-"
                    )}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Stack>

          <Stack spacing={0.5}>
            <Typography fontWeight="bold">Số dư chưa đủ gạt Phiếu: {formatCurrency(data?.data?.balanceAfter ?? 0)}</Typography>
            <Typography
              color="#989898"
              fontSize="12px"
              fontStyle="italic"
            >
              {convertCurrency(data?.data?.balanceAfter ?? 0)} đồng
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
